import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import fetchBannerAndStats from '../../../services/topicBanner';
import translate from '../../translate';
import Anchor from '../../Anchor';
import RewardsList from './components/RewardsList';

function TopicBanner() {
  const [{ message }, setMessage] = useState({
    message: null,
    stats: null,
  });
  useEffect(() => {
    fetchBannerAndStats().then(setMessage);
  }, []);

  const linkClass = cx({
    'topic-banner-content-link': true,
    'text-link': message ? message.type === 'text' : false,
  });

  return message ? (
    <div className="topic-banner-container-coins-points">
      <div className="topic-banner-content">
        <Anchor className={linkClass} href={message.link}>
          {message.type === 'text' && message.message}
          {message.type === 'banner' && (
            <img alt="topic message banner" src={message.banner} />
          )}
        </Anchor>
        <div className="rewardsContainer-list">
          <RewardsList />
        </div>
      </div>
    </div>
  ) : null;
}

TopicBanner.propTypes = {
};

export default React.memo(translate(TopicBanner));
